
import {
    Collapse,
    CollapseItem,
    Popup,
    Overlay,
    Icon,
    Cell,
    CellGroup
} from 'vant';


import 'vant/lib/popup/style';
import 'vant/lib/collapse/style';
import 'vant/lib/collapse-item/style';
import 'vant/lib/overlay/style';
import 'vant/lib/icon/style'
import 'vant/lib/cell/style'
import 'vant/lib/cell-group/style'

export default {
    install(Vue) {
        Vue.use(Collapse);
        Vue.use(CollapseItem);
        Vue.use(Popup);
        Vue.use(Overlay);
        Vue.use(Icon);
        Vue.use(Cell);
        Vue.use(CellGroup);
    }

}